
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';